import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Inicio" },
  { to: "/nosotros", label: "Nosotros" },
  { to: "/proyectos", label: "Proyectos" },
  { to: "/inversion", label: "Inversión" },
  { to: "/contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between h-20 px-4 md:px-8 lg:px-12">
        <Link to="/" className="flex items-center gap-2 group">
          <span
            className={`flex items-center justify-center rounded-md bg-white/95 px-2 py-1 transition-all duration-300 ${
              solid ? "shadow-sm" : "shadow-sm"
            }`}
          >
            <img
              src="https://static.readdy.ai/image/6e7b8f0ab6ca5454b0b0e1ae719b1e05/deb5691b4c1ab30634e35e35a0b57bed.jpeg"
              alt="Inmobiliaria ADJ"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `relative text-sm font-medium tracking-wide transition-colors whitespace-nowrap after:absolute after:-bottom-1 after:left-0 after:h-px after:bg-primary-400 after:transition-all after:duration-300 ${
                    isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
                  } ${solid ? "text-foreground-700 hover:text-foreground-950" : "text-background-100/90 hover:text-background-50"}`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/proyectos"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-yellow-400 hover:bg-yellow-300 text-foreground-950 text-sm font-semibold px-5 py-2.5 transition-colors duration-300"
          >
            VER PROYECTOS
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
          aria-expanded={open}
          className={`lg:hidden w-11 h-11 flex items-center justify-center rounded-md transition-colors ${
            solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {/* Menú móvil */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-background-50 border-b border-background-200/70 ${
          open ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <ul className="flex flex-col px-6 py-4 gap-1">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `block py-3 text-base font-medium border-b border-background-100 ${
                    isActive ? "text-primary-600" : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
          <li className="pt-4 pb-2">
            <Link
              to="/proyectos"
              className="w-full flex items-center justify-center gap-2 rounded-md bg-yellow-400 hover:bg-yellow-300 text-foreground-950 text-sm font-semibold px-5 py-3 transition-colors"
            >
              VER PROYECTOS
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}